'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DropShadow;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropShadow(props) {
    return _react2.default.createElement(
        'filter',
        { id: props.id },
        _react2.default.createElement('feGaussianBlur', { 'in': props.blurIn, stdDeviation: props.blurDeviation }),
        _react2.default.createElement('feOffset', { dx: props.dx, dy: props.dy }),
        _react2.default.createElement(
            'feMerge',
            null,
            _react2.default.createElement('feMergeNode', null),
            _react2.default.createElement('feMergeNode', { 'in': 'SourceGraphic' })
        )
    );
}

DropShadow.displayName = 'DropShadow';

DropShadow.propTypes = {
    id: _propTypes2.default.string.isRequired,
    dx: _propTypes2.default.number,
    dy: _propTypes2.default.number,
    blurDeviation: _propTypes2.default.number,
    blurIn: _propTypes2.default.oneOf(['SourceAlpha', 'SourceGraphic', 'BackgroundImage', 'BackgroundAlpha', 'FillPaint', 'StrokePaint'])
};

DropShadow.defaultProps = {
    dx: 1,
    dy: 1,
    blurDeviation: 4,
    blurIn: 'SourceAlpha'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/DropShadow.js
// module id = 1452
// module chunks = 0